import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
    PropsMessageBox,
    MessageBoxPermission,
    TextContentMessageBox,
    PropsCaptionMessageBox,
} from "../assets/windows/WindowMessageBox/modelsMessageBox";
import { IActionButtonNotification } from "../assets/components/ActionButtons/ActionButtons";

export type ActionValue = "yes" | "ok" | "no";

export type NotificationState = {
    textContent: TextContentMessageBox;
    stateWindow: MessageBoxPermission;
    actionButtons: IActionButtonNotification[] | undefined;
    open: boolean;
    actionValue: ActionValue | undefined;
    caption?: PropsCaptionMessageBox | undefined;
};

const initialState: NotificationState = {
    open: false,
    actionButtons: [],
    textContent: {
        title: "",
    },
    stateWindow: "information",
    actionValue: undefined,
    caption: {
        hideCaptionButtons: false,
        captionButtons: undefined,
    },
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        addNotification: (_state, action: PayloadAction<PropsMessageBox>) => ({
            ...initialState,
            ...action.payload,
            open: true,
        }),

        clearNotification: (_state, action: PayloadAction<ActionValue>) => ({
            ...initialState,
            actionValue: action.payload,
            open: false,
        }),
    },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice;
